import { Component } from "@angular/core";
import { ICellRendererAngularComp } from "ag-grid-angular";


export interface ILinkCellRendererComponentOptions {
  routerLinkParams?: any[];
  href?: string;
  value: string;
  target?: string;
}

@Component({
  selector: "lib-data-table-link",
  templateUrl: "./link-cell-renderer.component.html",
  styleUrls: ["./link-cell-renderer.component.scss"]
})
export class LinkCellRendererComponent implements ICellRendererAngularComp {

  public params: ILinkCellRendererComponentOptions;

  public agInit(params: ILinkCellRendererComponentOptions): void {
    this.params = params;
  }

  public refresh(): boolean {
    return false;
  }
}
